import axios from 'axios';

// Create an Axios instance
const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_SERVER_URL, // Set the base URL from env variable
    headers: {
        'Content-Type': 'application/json',
    },
});

console.log('Axios Instance Configuration:', {
    baseURL: axiosInstance.defaults.baseURL,
    headers: axiosInstance.defaults.headers,
});

// Set the Authorization header for every request
axiosInstance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('authToken');
        console.log('Outgoing Request:', config);
        console.log('Auth Token (Interceptor):', token); // Debugging token in interceptor
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        } else {
            console.warn('No Auth Token Found');
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// Intercept response to handle unauthorized errors and rate limit (429)
axiosInstance.interceptors.response.use(
    (response) => {
        // Successful response, simply return it
        return response;
    },
    async (error) => {
        // If the error is a 401 Unauthorized, redirect to login page
        if (error.response && error.response.status === 401) {
            console.log('401 Unauthorized - Redirecting to signin');
            // Remove auth token from localStorage and redirect to login page
            localStorage.removeItem('authToken');
            window.location.href = '/signin'; // Redirect to login page
        }

        // Handle 429 Too Many Requests (Rate Limiting)
        if (error.response && error.response.status === 429) {
            console.log('429 Too Many Requests - Rate limit exceeded');
            const retryAfter = error.response.headers['retry-after'];

            // Check if "Retry-After" header is present
            if (retryAfter) {
                // Retry the request after the specified delay (in seconds)
                console.log(`Retrying after ${retryAfter} seconds...`);
                await new Promise((resolve) => setTimeout(resolve, retryAfter * 1000));
                return axiosInstance(error.config); // Retry the request
            } else {
                // If no "Retry-After" header, handle it by notifying the user
                console.error('Too many requests. Please try again later.');
                alert('Kamu terlalu banyak melakukan request ke server. Tunggu sebentar kami sedang memproses request kamu, ya.');
            }
        }

        // If the error is not 401 or 429, propagate the error
        return Promise.reject(error);
    }
);

export default axiosInstance;
